module.exports = __webpack_public_path__ + "static/media/ziprefer-transparent.43b797ae.png";